import { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import NotifySettings from "../components/NotifySettings";
import SocialHub from "../components/share/SocialHub";
import VerifyEmailBanner from "../components/VerifyEmailBanner";
import RallyCard from "../components/RallyCard";
import { API, useAuth } from "../context/AuthContext";
import { Flame, Wrench, Flag, Brain, Swords, Tent, QrCode } from "lucide-react";
const PLAY_MENU = [["Daily Stage", "/daily", Flame, "Una nuova prova ogni giorno, gratis"], ["Rally Farm", "/farm", Wrench, "Crea il tuo mondo dei rally"], ["FantaRally", "/fantarally", Flag, "Pronostica assoluta, PS e classi"], ["Quiz", "/paddock?focus=QUIZ", Brain, "Quiz a tempo sponsorizzati"], ["Sfide", "/paddock?focus=SQUADRA", Swords, "Squadra fanta e sfide tra fan"], ["Paddock", "/paddock", Tent, "Tutti gli Official Paddock"], ["Missioni", "/paddock?focus=MISSIONI", QrCode, "Codici e QR sponsor"]];
import { Trophy, LogOut, Share2, CreditCard } from "lucide-react";
import DailyStageHero from "../components/daily/DailyStageHero";
import FarmHero from "../components/farm/FarmHero";
import CardWelcome from "../components/CardWelcome";
import { rallyStatus } from "../lib/dates";
import { FileText } from "lucide-react";

function MyPromax() {
  const nav = useNavigate(); const [boards, setBoards] = useState(null);
  useEffect(() => { axios.get(`${API}/promax/me/boards`).then(r => setBoards(r.data.boards || [])).catch(() => setBoards([])); }, []);
  if (!boards) return null;
  return (
    <div className="rl-card p-5 mb-6 border-[#FF9F0A]/30" data-testid="community-promax">
      <div className="flex items-center justify-between gap-3 mb-3"><div className="flex items-center gap-2"><img src="/rally-love-promax-logo.png" alt="PROMAX" className="h-6 w-auto" /><h2 className="font-display font-bold text-lg">I documenti dei miei rally</h2></div><button className="btn-outline-rl !py-1.5 !px-3 text-xs min-h-[40px]" onClick={() => nav("/promax/access")} data-testid="community-promax-access">INSERISCI CODICE</button></div>
      {boards.length === 0 ? <p className="text-sm text-slate-400">Non segui ancora nessun rally. Inserisci il codice evento dell'organizzatore per ricevere documenti e notifiche.</p> :
        <div className="grid sm:grid-cols-2 gap-2">{boards.map(b => <button key={b.id} onClick={() => nav(`/promax/event/${b.public_code}`)} className="rl-card p-3 text-left flex items-center justify-between gap-2 min-h-[56px]" data-testid={`community-board-${b.public_code}`}><div className="min-w-0"><div className="font-semibold truncate">{b.rally_name || b.name}</div><div className="text-xs text-slate-400 flex items-center gap-1"><FileText className="w-3 h-3" />{b.documents} documenti</div></div>{b.pending_acks > 0 && <span className="pill-badge pill-amber shrink-0">{b.pending_acks} nuovi</span>}</button>)}</div>}
    </div>
  );
}

export default function CommunityHome() {
  const { user, loading, logout } = useAuth();
  const nav = useNavigate();
  const [rallies, setRallies] = useState([]);
  const [season, setSeason] = useState(null);
  useEffect(() => { if (!loading && !user) nav("/login?next=/community"); }, [user, loading]);
  useEffect(() => {
    axios.get(`${API}/paddock/rallies`).then(r => setRallies(r.data)).catch(() => {});
    axios.get(`${API}/paddock/season/leaderboard`).then(r => setSeason(r.data)).catch(() => {});
  }, []);
  if (!user) return null;
  const me = season?.rows?.find(r => r.user_id === user.id);
  const live = rallies.filter(r => rallyStatus(r.start_date, r.end_date).code === "LIVE");
  const next = rallies.filter(r => rallyStatus(r.start_date, r.end_date).code === "UPCOMING").slice(0, 3);

  return (
    <div className="min-h-screen grain-bg">
      <Navbar />
      <section className="pt-24 pb-24 max-w-7xl mx-auto px-5 lg:px-8" data-testid="community-home">
        <div className="rl-banner rl-watermark p-6 md:p-10 mb-8 flex flex-wrap items-center justify-between gap-6">
          <div className="relative">
            <div className="pill-badge mb-3">AREA COMMUNITY</div>
            <h1 className="font-display font-black text-3xl md:text-5xl leading-none" data-testid="community-welcome">Ciao, {user.name?.split(" ")[0]}.</h1>
            <p className="text-slate-400 mt-2 text-sm">Il tuo quartier generale: FantaRally, quiz, missioni e classifiche.</p>
          </div>
          <div className="relative rl-card px-6 py-4 flex items-center gap-6" data-testid="community-season-card">
            <Trophy className="w-8 h-8 text-[#FF9F0A]" />
            <div><div className="text-[10px] font-mono-rl text-slate-400 tracking-widest">PUNTI STAGIONE</div><div className="font-display font-black text-3xl">{me?.points ?? 0}</div></div>
            <div><div className="text-[10px] font-mono-rl text-slate-400 tracking-widest">POSIZIONE</div><div className="font-display font-black text-3xl text-[#30D158]">{me ? `P${me.pos}` : "—"}</div></div>
          </div>
        </div>

        <VerifyEmailBanner />
        <MyPromax />
        <CardWelcome />
        <div className="mb-8"><DailyStageHero compact /></div>
        <FarmHero compact />
        <div className="flex flex-wrap gap-2 mb-8"><Link to="/card" className="btn-outline-rl flex items-center gap-2" data-testid="community-card-link"><CreditCard className="w-4 h-4" /> LA MIA RALLY LOVE CARD</Link></div>
        <h2 className="font-display font-bold text-xl mb-3">Gioca ora</h2>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mb-10">
          {PLAY_MENU.map(([label, to, Icon, desc]) => (
            <button key={label} onClick={() => nav(to)} data-testid={`community-play-${label.toLowerCase()}`}
              className="rl-card p-4 text-left min-h-[88px] hover:border-[#FF1E27]/50 hover:-translate-y-0.5 transition">
              <Icon className="w-5 h-5 text-[#FF9F0A] mb-2" /><div className="font-semibold">{label}</div><div className="text-xs text-slate-500">{desc}</div>
            </button>
          ))}
        </div>

        {live.length > 0 && (<>
          <h2 className="font-display font-bold text-xl mb-3 flex items-center gap-2"><span className="w-2 h-2 rounded-full bg-[#FF1E27] animate-pulse" /> In corso adesso</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-10">{live.map(r => <RallyCard key={r.id} r={r} testid={`community-live-${r.id}`} />)}</div>
        </>)}
        {next.length > 0 && (<>
          <h2 className="font-display font-bold text-xl mb-3">Prossimi rally</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-10">{next.map(r => <RallyCard key={r.id} r={r} testid={`community-next-${r.id}`} />)}</div>
        </>)}

        <div className="mb-8"><SocialHub /></div>
        <div className="flex flex-wrap gap-3 mb-8"><Link to="/share-center" className="btn-crimson !py-2 !px-4 text-xs min-h-[44px] inline-flex items-center gap-2" data-testid="community-share-center-link"><Share2 className="w-4 h-4" /> SHARE CENTER · CARD, SFIDE E INVITI</Link><Link to="/store" className="btn-outline-rl !py-2 !px-4 text-xs min-h-[44px] inline-flex items-center gap-2" data-testid="community-store-link">RALLY STORE · RALLY CREDITS</Link></div>
        <div className="grid md:grid-cols-2 gap-6">
          <div className="rl-card p-6" data-testid="community-profile">
            <h2 className="font-display font-bold text-xl mb-3">Profilo</h2>
            <div className="text-sm text-slate-300">{user.name}</div>
            <div className="text-sm text-slate-500 mb-4">{user.email} · {user.role}</div>
            <NotifySettings />
            <div className="flex flex-wrap gap-3 mt-5">
              <Link to="/season" className="btn-outline-rl !py-2 !px-4 text-xs">CLASSIFICA CAMPIONATO</Link>
              <button onClick={async () => { await logout(); nav("/"); }} className="text-xs text-slate-400 hover:text-white flex items-center gap-1 px-2" data-testid="community-logout"><LogOut className="w-4 h-4" /> Esci</button>
            </div>
          </div>
          <div className="rl-card p-6 text-sm text-slate-400">
            <h2 className="font-display font-bold text-xl mb-3 text-white">Come funziona</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>+25 punti FantaRally per ogni pronostico giocato, bonus pieno se indovini.</li>
              <li>Quiz a tempo: più sei veloce, più punti guadagni.</li>
              <li>Missioni sponsor: inserisci il codice trovato nel Paddock reale.</li>
              <li>Tutti i punti si sommano nel Campionato Fan della stagione.</li>
            </ul>
            <p className="text-xs text-slate-500 mt-4">FANTARALLY utilizza esclusivamente punti virtuali. Non sono previste scommesse o vincite in denaro.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
